<div class="usage-limit-input" [ngClass]="view">
  <div>
    @if (!context.noLabel) {
      <label
        [attr.aria-hidden]="true"
        id="{{ labelId }}"
        class="label mb-1 text-nowrap"
        [ngClass]="{ required: required }"
        [class.visuallyhidden]="context.hiddenLabel"
      >
        {{ context.label | translate }}
      </label>
    }
    @if (context.tooltip) {
      <button class="btn margin-left-sm" [appTooltip]="context.tooltip | translate">
        <svg class="open-icon margin-bottom-xs" width="1rem" height="1rem" aria-hidden="true">
          <use xlink:href="#question-mark-2"></use>
        </svg>
        <span class="visually-hidden">{{ context.tooltip | translate }}</span>
      </button>
    }
  </div>
  <div class="row">
    <div class="col-6 end-align">
      <input
        type="number"
        min="0"
        id="{{ context.id ?? context.field }}"
        class="form-element included-amount"
        [class.w-100]="fullWidthInput"
        [class.ng-invalid]="form?.get(this.context.field)?.invalid"
        [ngStyle]="context.width ? { width: context.width } : { width: '6rem !important' }"
        [placeholder]="context.placeholder ? (context.placeholder | translate) : ''"
        [name]="context.field"
        [(ngModel)]="displayValue"
        [ngModelOptions]="{ standalone: true }"
        [attr.aria-label]="customLabel | translate"
        [attr.aria-describedby]="context.field ? context.field + '_error' : ''"
        [attr.aria-invalid]="form ? (form | fieldInvalid: context.field) : null"
        [attr.aria-required]="required"
        [attr.disabled]="context.disabled ? true : null"
        [attr.required]="context.required ? '' : null"
        [readOnly]="readonly"
      />
      @if (context.maxLimit) {
        <div [id]="(context.id ?? context.field) + '_maxAmountLabel'" class="bottom-label">
          {{ 'max' | translate }} {{ context.maxLimit }}
        </div>
      }
    </div>
  </div>
  <div [id]="(context.id ?? context.field) + '_error'" class="error-container">
    <app-form-field-error
      [formValidationRequest$]="formValidationRequest$"
      [field]="form?.get(context.field)"
      [name]="context.field"
      [label]="context.label"
      [customMessage]="context.customMessage"
      [overrideErrors]="context.overrideErrors"
    ></app-form-field-error>
  </div>
</div>
